import React, { useState, useEffect } from 'react';
import loadingMessages from '../data/loading-messages.json';
import '../styles/LoadingGrid.css';

function LoadingGrid() {
  const [currentMessage, setCurrentMessage] = useState(loadingMessages.messages[0]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % loadingMessages.messages.length;
      setCurrentMessage(loadingMessages.messages[currentIndex]);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="loading-container">
      <div className="loading-message">{currentMessage}</div>
      <div className="loading-grid">
        {[...Array(6)].map((_, index) => (
          <div key={index} className={`loading-card ${isMobile ? 'mobile' : ''}`}>
            {isMobile ? (
              <>
                <div className="loading-mobile-header">
                  <div className="loading-checkbox" />
                  <div className="loading-type-bar" />
                </div>
                <div className="loading-title-bar" />
                <div className="loading-card-content">
                  <div className="loading-line" />
                  <div className="loading-line" />
                  <div className="loading-line short" />
                </div>
                <div className="loading-mobile-dates">
                  <div className="loading-date-bar" />
                  <div className="loading-date-bar" />
                </div>
                <div className="loading-mobile-actions">
                  <div className="loading-action-button" />
                  <div className="loading-action-button" />
                  <div className="loading-action-button" />
                  <div className="loading-action-button" />
                </div>
              </>
            ) : (
              <>
                <div className="loading-checkbox" />
                <div className="loading-card-header">
                  <div className="loading-top">
                    <div className="loading-type-bar" />
                  </div>
                  <div className="loading-title-bar" />
                  <div className="loading-actions">
                    <div className="loading-action-button" />
                    <div className="loading-action-button" />
                    <div className="loading-action-button" />
                  </div>
                </div>
                <div className="loading-card-content">
                  <div className="loading-line" />
                  <div className="loading-line" />
                  <div className="loading-line short" />
                </div>
                <div className="loading-card-footer">
                  <div className="loading-date-items">
                    <div className="loading-date-bar" />
                    <div className="loading-date-bar" />
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default LoadingGrid; 